/*! @azure/msal-common v14.10.0 2024-05-07 */
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * Protocol modes supported by MSAL.
 */
const ProtocolMode = {
    AAD: "AAD",
    OIDC: "OIDC",
};

export { ProtocolMode };
//# sourceMappingURL=ProtocolMode.mjs.map
